exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".DeviceManagement {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n", "", {"version":3,"sources":["D:/code_workspace/vue_work/ming-iot-admin/src/assets/css/D:/code_workspace/vue_work/ming-iot-admin/src/assets/css/DeviceManagement.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;CACd","file":"DeviceManagement.css","sourcesContent":[".DeviceManagement {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--5-1!./node_modules/postcss-loader/lib??ref--5-2!./src/assets/css/DeviceManagement.css
// module id = LyrG
// module chunks = 1